<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table :table-data="data" :loading="loading" :per-page="10" :bordered="true" :table-detail="tableDetail"
          :hover="true" :striped="false" :fields="fields" :row-edit="employeeTaskVerificationForm"
          :redirect-detail="false" :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Verifikasi Pekerjaan Karyawan Listing"
          addButton="Tambah Verifikasi Pekerjaan Karyawan" @editForm="editForm" @resetForm="resetForm"></global-table>

        <b-modal ref="myModalRef" id="addModals" header-border-variant="no-border text-center"
          footer-border-variant="no-border" footer-bg-variant="light" :no-close-on-backdrop="true"
          :no-close-on-esc="true" size="lg">
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Verifikasi Perjanjian Freezer Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Verifikasi Perjanjian Freezer</h3>
          </div>

          <b-form id="employeeTaskVerificationForm" validated novalidate>
            <b-row>
              <b-col sm="4">
                <b-form-group label-for="title" label="Title">
                  <b-form-input id="title" type="text" v-model="$v.employeeTaskVerificationForm.title.$model"
                    :state="!$v.employeeTaskVerificationForm.title.$invalid" required
                    :readonly="isEdit"
                    placeholder="Title working"></b-form-input>
                  <b-form-invalid-feedback>Title harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label-for="employee_id" label="Tugas Untuk Karyawan">
                  <model-select id="employee_id" :options="listEmployee"
                    v-model="$v.employeeTaskVerificationForm.employee_id.$model"
                    :isError="$v.employeeTaskVerificationForm.employee_id.$invalid"
                    :isDisabled="isEdit"
                    placeholder="-- Harap pilih salah satu --"></model-select>
                  <div v-if="employeeTaskVerificationForm.employee_id === null" class="invalid-feedback-custom">
                    Tugas untuk karyawan harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="4">
                <b-form-group label-for="customer_id" label="Verifikasi Perjanjian Freezer Untuk Outlet" v-if="!isEdit">
                  <vue-autosuggest v-model="customers.text" @inputout="focusMe" :suggestions="filteredOptions"
                    @input="onInputChange" @selected="onSelected"
                    :input-props="{ id: 'customer', placeholder: 'Find Customer', class: 'form-control' }" :limit="20">
                    <template slot-scope="{ suggestion }">
                      <span class="my-suggestion-item">
                        {{ suggestion.item.text }}
                      </span>
                    </template>
                  </vue-autosuggest>
                </b-form-group>
                <template>
                  <div>Verifikasi Perjanjian Freezer Untuk Outlet:<br />
                    <strong>{{ (customers.text !== null) ? customers.text : '-' }}</strong>
                  </div>
                </template>
              </b-col>
              <b-col sm="4">
                <b-form-group label-for="template_id" label="Template Verifikasi">
                  <model-select id="template_id" :options="listTemplate"
                    v-model="$v.employeeTaskVerificationForm.template_id.$model"
                    :isDisabled="isEdit"
                    :isError="$v.employeeTaskVerificationForm.template_id.$invalid"
                    placeholder="-- Harap pilih salah satu --"></model-select>
                  <div v-if="employeeTaskVerificationForm.template_id === null" class="invalid-feedback-custom">
                    Template Verifikasi harus di isi.
                  </div>
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group label-for="request_code" label="Masukkan Request Code" v-if="!isEdit">
                  <vue-autosuggest v-model="request.text" @inputout="focusMe2" :suggestions="filteredOptions2"
                    @input="onInputChange2" @selected="onSelected2"
                    :input-props="{ id: 'request_code', placeholder: 'Find Request Code', class: 'form-control' }"
                    :limit="20">
                    <template slot-scope="{ suggestion }">
                      <span class="my-suggestion-item">
                        {{ suggestion.item.text }}
                      </span>
                    </template>
                  </vue-autosuggest>
                </b-form-group>
                <template>
                  <div>Request Code:<br />
                    <strong>{{ (request.text !== null) ? request.text : '-' }}</strong>
                  </div>
                </template>
              </b-col>

            </b-row>

            <b-row v-if="isEdit">
              <b-col sm="4">
                <b-form-group label-for="status_verification" label="Status Pekerjaan">
                  <model-select id="status_verification" :options="listVerificationStatus"
                    v-model="$v.employeeTaskVerificationForm.status_verification.$model"
                    :isError="$v.employeeTaskVerificationForm.status_verification.$invalid"
                    placeholder="-- Harap pilih salah satu --"></model-select>
                  <div v-if="employeeTaskVerificationForm.status_verification === null" class="invalid-feedback-custom">
                    Status Pekerjaan harus di isi.
                  </div>
                </b-form-group>
              </b-col>
              <b-col sm="8">
                <b-form-group label-for="reason" label="Alasan">
                  <b-form-textarea id="reason" :rows="3" :max-rows="6"
                    v-model="$v.employeeTaskVerificationForm.reason.$model"
                    :state="!$v.employeeTaskVerificationForm.reason.$invalid" required></b-form-textarea>
                  <b-form-invalid-feedback>Alasan harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

          </b-form>

          <div slot="modal-footer" class="float-right">
            <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
              <i class="fa fa-undo"></i> Back </b-button>&nbsp;
            <b-button
              type="button" size="sm" variant="primary" @click="saveProcess"
              :disabled="$v.employeeTaskVerificationForm.$invalid">
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import { VueAutosuggest } from 'vue-autosuggest';
import custom_validation from "@/templates/_customValidation.js";
import { readonly } from "vue";

export default {
  name: "verification-template",
  components: { globalTable, ModelSelect, VueAutosuggest },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      loading: true,
      listCustomer: [],
      listEmployee: [],
      listTemplate: [],
      listVerificationStatus: [],
      listStatus: [
        { 'value': '1', 'text': 'Show' },
        { 'value': '2', 'text': 'Hide' }
      ],

      fields: [
        { key: "title", label: "Title", sortable: true },
        { key: "customer_name", label: "Outlet" },
        { key: "status_label", label: "Status" },
        { key: "updated_time", label: "Tanggal Update" },
        { key: "status_verification_name", label: "Status Pekerjaan" },
        { key: "reason", label: "Alasan" },
        { key: "action", class: "text-center width-80" },
      ],
      employeeTaskVerificationForm: masterInterfaces.employee_task_verification,
      isEdit: false,
      customers: {
        text: null,
        value: null
      },
      request: {
        text: null,
        value: null
      },
      filteredOptions: [],
      filteredOptions2: [],
      suggestions: [
        {
          data: [],
        },
      ],
      suggestions_req_code: [
        {
          data: [],
        },
      ]
    };
  },
  validations() {
    if (this.isEdit === true) {
      return custom_validation.verification_agreement_freezer.edit;
    } else {
      return custom_validation.verification_agreement_freezer.add;
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.getVerificationEmployeeList();
      this.getDropdown();
    },
    getVerificationEmployeeList: function () {
      this.axios
        .get("web/verification-task/customer/")
        .then((response) => {
          this.data = response.data.data;
        })
        .catch((error) => { })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("web/dropdown/dropdown-task-verification/1")
        .then(response => {
          this.listCustomer = response.data.customer;
          this.listEmployee = response.data.employee;
          this.listTemplate = response.data.template;
          this.listVerificationStatus = response.data.employee_task_verification_status
        })
        .catch(error => { })
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (e) {
      this.isEdit = true;
      this.employeeTaskVerificationForm = e;
      this.customers.value = e.customer_id;
      this.customers.text = e.customer_name;
      this.request.value = e.freezer_request_code;
      this.request.text = e.freezer_request_code;
    },
    resetForm: function () {
      for (var a in masterInterfaces.employee_task_verification) {
        masterInterfaces.employee_task_verification[a] = null;
      }
      this.employeeTaskVerificationForm = masterInterfaces.employee_task_verification;
      this.customers.value = null;
      this.customers.text = null;
      this.request.value = null;
      this.request.text = null;
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
      this.resetForm();
    },
    saveProcess: function (evt) {
      evt.preventDefault();
      this.employeeTaskVerificationForm.category = 1;
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah template ini?")) {
          this.axios
            .put(
              "web/verification-task/customer/edit/",
              this.employeeTaskVerificationForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Template Berhasil",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error, "Ubah Template");
            })
            .finally(() => {
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan template ini?")) {
          this.axios
            .post(
              "web/verification-task/customer/add/",
              this.employeeTaskVerificationForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Template Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Template Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error, "Tambah Template");
            })
            .finally(() => {
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        this.employeeTaskVerificationForm.customer_id = null;
        return;
      } else {
        this.customers.value = item.item.value;
        this.customers.text = item.item.text;
        this.employeeTaskVerificationForm.customer_id = item.item.value;
      }
    },
    focusMe: function (item) {
      if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        this.employeeTaskVerificationForm.customer_id = null;
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.customers.value = null;
        this.customers.text = null;
        this.employeeTaskVerificationForm.customer_id = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-customer/", { 'name': text })
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => { })
          .finally(() => { });
      }
    },

    onSelected2(item) {
      if (item === "" || item === undefined || item === null) {
        this.request.value = null;
        this.request.text = null;
        this.employeeTaskVerificationForm.freezer_request_code = null;
        return;
      } else {
        this.request.value = item.item.value;
        this.request.text = item.item.text;
        this.employeeTaskVerificationForm.freezer_request_code = item.item.value;
      }
    },
    focusMe2: function (item) {
      if (item === "" || item === undefined || item === null) {
        this.request.value = null;
        this.request.text = null;
        this.employeeTaskVerificationForm.freezer_request_code = null;
        return;
      }
    },
    onInputChange2(text) {
      if (text === "" || text === undefined || text === null) {
        this.request.value = null;
        this.request.text = null;
        this.employeeTaskVerificationForm.freezer_request_code = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-request-freezer/", { 'name': text })
          .then((response) => {
            this.dropdown_code = response.data.data;
            this.suggestions_req_code[0].data = this.dropdown_code;
            const filteredData = this.suggestions_req_code[0].data;
            this.filteredOptions2 = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => { })
          .finally(() => { });
      }
    },


    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.demo {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

input {
  width: 260px;
  padding: 0.5rem;
}

.autosuggest__results>ul {
  width: 100%;
  color: rgba(30, 39, 46, 1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
}

.autosuggest__results>ul>li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}

.autosuggest__results>ul>li:hover {
  cursor: pointer;
}

.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}

#autosuggest {
  width: 100%;
  display: block;
}

.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178, 0.2);
}

#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  font-family: monospace;
  font-size: 20px;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  overflow: scroll;
  max-height: 200px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1)>.autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #b6adad;
}
</style>